module.exports = __webpack_public_path__ + "../../../static/img/c_im_5.ac0fa067.png";